import React from 'react';
import ReactDOM from 'react-dom';

const $ = window.$;

export class PreventParentScroll extends React.Component {
    handleRefScrollable = (element) => {
        this.element = element;
    }

    handleScrollableWheel = (event, d) => {
        let $element = $(ReactDOM.findDOMNode(this.element));
        if(event.deltaY < 0 && $element.scrollTop() === 0) {
            event.preventDefault();
        } else if (event.deltaY > 0 && $element.scrollTop() === $element.get(0).scrollHeight - $element.innerHeight()) {
            event.preventDefault();
        }
    }

    render() {
        return this.props.children({
            refScrollable: this.handleRefScrollable,
            onScrollableWheel: this.handleScrollableWheel,
        })
    }
}


// WEBPACK FOOTER //
// ./src/visual/component/PreventParentScroll.js